import { Container } from '@/components/container';
import { SubNavContainer } from '@/components/sub-nav-container';
import { useAuthStore } from '@/store/auth';
import { Avatar, AvatarFallback, AvatarImage } from '@opaz/ui-components';
import { createFileRoute } from '@tanstack/react-router';
import { AllTasksCard } from '../dashboard/-components/AllTasksCard';
import { getAvatarInitials, getLocalizedName } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_auth/tasks/')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: 'breadcrumbs.tasks',
      }),
    };
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Tasks - OPAZ E-Service Portal',
        },
      ],
    };
  },
});

function RouteComponent() {
  const { activeProfile } = useAuthStore();
  const { i18n } = useTranslation();

  return (
    <>
      <SubNavContainer>
        <div className="flex gap-4 items-center">
          <Avatar size="lg" status="online">
            <AvatarImage src="/avatars/01.png" />
            <AvatarFallback>
              {getAvatarInitials(getLocalizedName(activeProfile?.nameEn, activeProfile?.nameAr, i18n.language))}
            </AvatarFallback>
          </Avatar>

          <div className="flex flex-col">
            <p className="text-[32px] font-bold text-foreground">
              {getLocalizedName(activeProfile?.nameEn, activeProfile?.nameAr, i18n.language)}
            </p>
            <p className="text-xl text-muted-foreground">{activeProfile?.identifier}</p>
          </div>
        </div>
      </SubNavContainer>

      <Container>
        <AllTasksCard />
      </Container>
    </>
  );
}
